export default {"src":"/_next/static/media/rasberry_logo.5b798c2e.svg","height":42,"width":34,"blurWidth":0,"blurHeight":0};